module.exports = __webpack_public_path__ + "static/img/Ellipse_bjl.682319d4.png";